import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField, RadioButton } from "ui";

import { ContentVideoTargetResellerLevel } from "../../../../constants";
import { VideoFormAtomProps } from "../VideoForm.types";

import styles from "../VideoForm.module.scss";

const TargetResellerLevelField = ({ control }: VideoFormAtomProps) => {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name="targetResellerLevel"
      render={({ field: { value, onChange } }) => (
        <FormField label={"User type"}>
          <div className={styles.form_userTypeOptions}>
            <RadioButton
              label={t("All")}
              onChange={() => onChange(null)}
              checked={value === null}
            />

            <RadioButton
              label={t("Buyer")}
              value={ContentVideoTargetResellerLevel.Buyer}
              onChange={onChange}
              checked={value === ContentVideoTargetResellerLevel.Buyer}
            />

            <RadioButton
              label={t("Reseller")}
              value={ContentVideoTargetResellerLevel.Reseller}
              onChange={onChange}
              checked={value === ContentVideoTargetResellerLevel.Reseller}
            />
          </div>
        </FormField>
      )}
    />
  );
};

export default TargetResellerLevelField;
